import { render, staticRenderFns } from "./buyList.vue?vue&type=template&id=336be0f0&scoped=true"
import script from "./buyList.vue?vue&type=script&lang=js"
export * from "./buyList.vue?vue&type=script&lang=js"
import style0 from "./buyList.vue?vue&type=style&index=0&id=336be0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336be0f0",
  null
  
)

export default component.exports